export const isBrowser = () => {
  return typeof window !== 'undefined'
}

export const generateUUID = () => {
  let d = new Date().getTime()
  return 'xxxxxxxxxxxx4xxxyxxxxx'
    .replace(/[xy]/g, function (c) {
      const r = ((d + Math.random() * 16) % 16) | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
    .concat('-' + new Date().getTime())
    .concat('-PEX')
}

export const getAceEndpoint = ({ internalEndpoint, externalEndpoint }) =>
  isBrowser() ? externalEndpoint : internalEndpoint

export const getServerUrl = (req) => {
  return req.protocol && req.get('host') && req.originalUrl
    ? `${req.protocol}://${req.get('host')}${req.originalUrl}`
    : (req?.url ?? '')
}

export const getServerGlobals = (req) => ({
  ua: req.get('user-agent'),
  ref: req.get('referrer'),
  language: req.get('accept-language') || 'en-US,en;',
  url: getServerUrl(req),
  cookie: req.get('cookie'),
})

export const getClientGlobals = (window, document) => {
  return {
    ua: window?.navigator?.userAgent,
    ref: document?.referrer,
    language: window?.navigator?.userLanguage || window?.navigator?.language || 'en-US,en;',
    url: window?.location?.href,
    cookie: document?.cookie,
  }
}

export const getMetadataHash = (metadata = {}) => {
  const hash = Object.keys(metadata)
    .map((key) => `${key}~${metadata[key]}`)
    .join('|')

  return hash.length ? `|${hash}|` : '|'
}

export const getCookieByName = (cookieName, globals) => {
  const regEx = new RegExp('(?:^|;)\\s?' + cookieName + '=(.*?)(?:;|$)', 'i')
  const cookie = globals?.cookie
  const match = typeof cookie === 'string' && cookie.match(regEx)

  // GMS(08/15/2017): added replace logic to remove CGUID of pattern "ID=abcdefgh"
  return !!match && match.length > 0
    ? decodeURI(match[match.length - 1]).replace(/"([^"]+(?="))"/g, '$1')
    : null
}

export const getClientGuid = (globals) => {
  const cookie = getCookieByName('SITESERVER', globals)
  return cookie
    ? cookie
        .split('=')
        .filter((value) => value !== 'ID')
        .shift()
    : null
}

// check if roll() call failed in mid-tier (node)
export const checkIsValidImpression = (experimentData, experimentTagName, debugFireImpression) =>
  experimentData?.[experimentTagName]?.resultMessage !== 'ROLL FAILURE' &&
  (debugFireImpression || experimentData?.[experimentTagName]?.resultCode === 200)

export const buildExperimentData = (experimentAssignments) => {
  return Array.isArray(experimentAssignments)
    ? experimentAssignments
        .filter((item) => item.setiTagName)
        .reduce(
          (data, item) =>
            Object.assign(data, {
              [item.setiTagName]: item,
            }),
          {},
        )
    : {}
}
